import { render, staticRenderFns } from "./sxt.vue?vue&type=template&id=3dd23f40"
import script from "./sxt.vue?vue&type=script&lang=js"
export * from "./sxt.vue?vue&type=script&lang=js"
import style0 from "./sxt.vue?vue&type=style&index=0&id=3dd23f40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports